import styleButton from "../../../../shared/components/rbh-button/styles";
import { Colors } from "../../../../shared/theme";
import { textStyles } from "../../../../shared/theme/fonts-ppv";

export default {
  DragHandleStyle: {
    cursor: "grab",
  } as React.CSSProperties,
  DraggingItemStyle: {
    backgroundColor: "#F0F0F0",
  } as React.CSSProperties,
  DroppableAreaStyle: {
    backgroundColor: "#FFFFFF",
  } as React.CSSProperties,
  DroppingAreaStyle: {
    backgroundColor: "#E8E8E8",
  } as React.CSSProperties,
  MenuPhotoStyle: {
    width: 48,
    height: 48,
    objectFit: "cover",
    borderRadius: 8,
  } as React.CSSProperties,
  ActionContainerStyle: {
    display: "flex",
    gap: 16,
    justifyContent: "center",
  } as React.CSSProperties,
  buttonAdd: {
    ...styleButton,
    ...textStyles.button2,
    color: Colors.white,
    borderRadius: "24px",
    borderColor: Colors.violet,
    background: Colors.violet,
  },
};
